import { Download } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import WorkIcon from '@mui/icons-material/Work';
import { Button, Chip, Divider, Grid, Menu, MenuItem, Stack, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { APEX_AUTO_APP, SHOP_CREATED, SHOP_IMPORTED, WALK_IN } from '../../../config/dataService/constants';
import useRecordPaymentStore from '../../../store/UseRecordPaymentStore';
import { CHIP_COLOR, CONTACT_PREFRENCES } from '../../../utility/Constant';
import BalanceOwingSvg from '../../../utility/Svg/BalanceOwingSvg';
import ContactPreferenceSvg from '../../../utility/Svg/ContactPreferenceSvg';
import RecordPaymentSvg from '../../../utility/Svg/RecordPaymentSvg';
import TaxExemptionSvg from '../../../utility/Svg/TaxExemptionSvg';
import { NumericEngine } from '../../../utility/helpers/numericEngine';
import { formatPhoneNumber } from '../../Common/FormatPhoneNumber';
import StatementAccountReportModal from '../../Invoice/StatementAccountReportModal';

const EllipsisEmail = ({ email }) => {
    const [isTruncated, setIsTruncated] = useState(false);

    const checkTruncation = (e) => {
        const el = e.currentTarget;
        setIsTruncated(el.scrollWidth > el.clientWidth);
    };

    return (
        <Tooltip title={email} arrow disableHoverListener={!isTruncated}>
            <Typography
                onMouseEnter={checkTruncation}
                style={{
                    fontSize: '16px',
                    fontWeight: 400,
                    lineHeight: '143%',
                    letterSpacing: '0.17px',
                    textAlign: 'right',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    minWidth: 0,
                    flex: 1,
                }}
            >
                {email}
            </Typography>
        </Tooltip>
    );
};

export function PhoneTypeIcon(type, width = '20px', height = '20px') {
    const iconWrapperStyle = {
        width: width,
        height: height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    };

    if (type == 'home')
        return (
            <span style={iconWrapperStyle}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" fill="none">
                    <path d="M8 17V11H12V17H17V9H20L10 0L0 9H3V17H8Z" fill="#006CDD" />
                </svg>
            </span>
        );
    if (type == 'work')
        return (
            <span style={iconWrapperStyle}>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path
                        d="M15.75 16.8V3.6H12.375V0H2.25V16.8H0V18H7.875V14.4H10.125V18H18V16.8H15.75ZM6.75 12H4.5V9.6H6.75V12ZM6.75 8.4H4.5V6H6.75V8.4ZM6.75 4.8H4.5V2.4H6.75V4.8ZM10.125 12H7.875V9.6H10.125V12ZM10.125 8.4H7.875V6H10.125V8.4ZM10.125 4.8H7.875V2.4H10.125V4.8ZM14.625 12H12.375V9.6H14.625V12ZM14.625 8.4H12.375V6H14.625V8.4Z"
                        fill="#006CDD"
                    />
                </svg>
            </span>
        );
    if (type == 'landline')
        return (
            <span style={iconWrapperStyle}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                    <path
                        d="M17.2903 10.253C17.1938 9.586 16.6764 9.066 16.0102 8.911C13.4211 8.307 12.772 6.823 12.6625 5.177C12.2034 5.092 11.3865 5 10 5C8.61349 5 7.79666 5.092 7.3375 5.177C7.22799 6.823 6.57894 8.307 3.98977 8.911C3.32364 9.067 2.80621 9.586 2.70976 10.253L2.21042 13.695C2.03459 14.907 2.92879 16 4.17263 16H15.8274C17.0702 16 17.9654 14.907 17.7896 13.695L17.2903 10.253ZM10 13.492C8.59842 13.492 7.46209 12.372 7.46209 10.992C7.46209 9.612 8.59842 8.492 10 8.492C11.4016 8.492 12.5379 9.612 12.5379 10.992C12.5379 12.372 11.4006 13.492 10 13.492ZM19.997 4C19.9729 2.5 16.1368 0.001 10 0C3.86217 0.001 0.0261544 2.5 0.00304589 4C-0.0200627 5.5 0.0241451 7.452 2.55001 7.127C5.50489 6.746 5.32304 5.719 5.32304 4.251C5.32304 3.227 7.72633 2.98 10 2.98C12.2737 2.98 14.676 3.227 14.677 4.251C14.677 5.719 14.4951 6.746 17.45 7.127C19.9749 7.452 20.0201 5.5 19.997 4Z"
                        fill="#006CDD"
                    />
                </svg>
            </span>
        );
    if (type == 'mobile')
        return (
            <span style={iconWrapperStyle}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none">
                    <path
                        d="M10.004 0H1.996C1.46663 0 0.958937 0.210292 0.584615 0.584615C0.210292 0.958938 0 1.46663 0 1.996V18.003C0 19.106 0.894 20 1.996 20H10.003C10.5325 20 11.0403 19.7897 11.4147 19.4154C11.7892 19.0412 11.9997 18.5335 12 18.004V1.996C12 1.46663 11.7897 0.958938 11.4154 0.584615C11.0411 0.210292 10.5334 0 10.004 0ZM6 19C5.31 19 4.75 18.553 4.75 18C4.75 17.447 5.31 17 6 17C6.69 17 7.25 17.447 7.25 18C7.25 18.553 6.69 19 6 19ZM10 16H2V2H10V16Z"
                        fill="#006CDD"
                    />
                </svg>
            </span>
        );
}

export function SmallPhoneTypeIcon(type, width = '16px', height = '16px') {
    const iconWrapperStyle = {
        width: width,
        height: height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    };

    if (type == 'home')
        return (
            <span style={iconWrapperStyle}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M8.0001 16V11.2H11.2001V16H15.2001V9.59999H17.6001L9.6001 2.39999L1.6001 9.59999H4.0001V16H8.0001Z" fill="#006CDD" />
                </svg>
            </span>
        );
    if (type == 'work')
        return (
            <span style={iconWrapperStyle}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                        d="M11.2032 0H4.79675C4.37325 0 3.9671 0.168234 3.66764 0.467692C3.36818 0.76715 3.19995 1.1733 3.19995 1.5968V14.4024C3.19995 15.2848 3.91515 16 4.79675 16H11.2024C11.6259 16 12.0322 15.8318 12.3317 15.5324C12.6313 15.2329 12.7997 14.8268 12.8 14.4032V1.5968C12.8 1.1733 12.6317 0.76715 12.3323 0.467692C12.0328 0.168234 11.6266 0 11.2032 0ZM7.99995 15.2C7.44795 15.2 6.99995 14.8424 6.99995 14.4C6.99995 13.9576 7.44795 13.6 7.99995 13.6C8.55195 13.6 8.99995 13.9576 8.99995 14.4C8.99995 14.8424 8.55195 15.2 7.99995 15.2ZM11.2 12.8H4.79995V1.6H11.2V12.8Z"
                        fill="#006CDD"
                    />
                </svg>
            </span>
        );
    if (type == 'landline')
        return (
            <span style={iconWrapperStyle}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <g clip-path="url(#clip0_23407_616178)">
                        <path
                            d="M13.8048 9.80241C13.728 9.26881 13.316 8.85281 12.7856 8.72881C10.724 8.24561 10.2072 7.05841 10.12 5.74161C9.75442 5.67361 9.10402 5.60001 8.00002 5.60001C6.89602 5.60001 6.24562 5.67361 5.88002 5.74161C5.79282 7.05841 5.27602 8.24561 3.21442 8.72881C2.68402 8.85361 2.27202 9.26881 2.19522 9.80241L1.79762 12.556C1.65762 13.5256 2.36962 14.4 3.36002 14.4H12.64C13.6296 14.4 14.3424 13.5256 14.2024 12.556L13.8048 9.80241ZM8.00002 12.3936C6.88402 12.3936 5.97922 11.4976 5.97922 10.3936C5.97922 9.28961 6.88402 8.39361 8.00002 8.39361C9.11602 8.39361 10.0208 9.28961 10.0208 10.3936C10.0208 11.4976 9.11522 12.3936 8.00002 12.3936ZM15.96 4.80001C15.9408 3.60001 12.8864 1.60081 8.00002 1.60001C3.11282 1.60081 0.0584229 3.60001 0.0400229 4.80001C0.0216229 6.00001 0.056823 7.56161 2.06802 7.30161C4.42082 6.99681 4.27602 6.17521 4.27602 5.00081C4.27602 4.18161 6.18962 3.98401 8.00002 3.98401C9.81042 3.98401 11.7232 4.18161 11.724 5.00081C11.724 6.17521 11.5792 6.99681 13.932 7.30161C15.9424 7.56161 15.9784 6.00001 15.96 4.80001Z"
                            fill="#006CDD"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_23407_616178">
                            <rect width="16" height="16" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
            </span>
        );
    if (type == 'mobile')
        return (
            <span style={iconWrapperStyle}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20" fill="none">
                    <path
                        d="M10.004 0H1.996C1.46663 0 0.958937 0.210292 0.584615 0.584615C0.210292 0.958938 0 1.46663 0 1.996V18.003C0 19.106 0.894 20 1.996 20H10.003C10.5325 20 11.0403 19.7897 11.4147 19.4154C11.7892 19.0412 11.9997 18.5335 12 18.004V1.996C12 1.46663 11.7897 0.958938 11.4154 0.584615C11.0411 0.210292 10.5334 0 10.004 0ZM6 19C5.31 19 4.75 18.553 4.75 18C4.75 17.447 5.31 17 6 17C6.69 17 7.25 17.447 7.25 18C7.25 18.553 6.69 19 6 19ZM10 16H2V2H10V16Z"
                        fill="#006CDD"
                    />
                </svg>
            </span>
        );
}

function CustomerProfileLeftDataSection({ data, importedCustomerData, setQuickEdit = () => {}, setOpenEditCustomer, setOpenDelete }) {
    const { id, type } = useParams();
    const [statementAccountModal, setStatementAccountModal] = useState(false);
    const { recordPaymentParams, setRecordPaymentParams, setCustomerDetail } = useRecordPaymentStore();

    const navigate = useNavigate();
    const isRestrictedCustomerType = type === SHOP_IMPORTED || type === WALK_IN || type === 'shop_guest';

    const customerAddress = () => {
        let add = ' ';
        if (data?.streetAddress) {
            add += data?.streetAddress;
        }
        if (data?.city) {
            if (add.trim() != '') add += ', ' + data?.city?.city;
            else add += data?.city?.city;
        }
        if (data?.province) {
            if (add.trim() != '') add += ', ' + data?.province?.province;
            else add += data?.province?.province;
        }

        if (data?.postalCode) {
            if (add.trim() != '') add += ', ' + data?.postalCode;
            else add += data?.postalCode;
        }
        return add;
    };
    const importCustomerAddress = () => {
        let add = ' ';
        if (importedCustomerData?.streetAddress) {
            if (add.trim() != '') add += ', ' + importedCustomerData?.streetAddress;
            else {
                add += importedCustomerData?.streetAddress;
            }
        }
        if (importedCustomerData?.city) {
            if (add.trim() != '') add += ', ' + importedCustomerData?.city?.city;
            else add += importedCustomerData?.city?.city;
        }
        if (importedCustomerData?.province) {
            if (add.trim() != '') add += ', ' + importedCustomerData?.province?.province;
            else add += importedCustomerData?.province?.province;
        }

        if (importedCustomerData?.postalCode) {
            if (add.trim() != '') add += ', ' + importedCustomerData?.postalCode;
            else add += importedCustomerData?.postalCode;
        }
        return add;
    };

    const [anchorEl, setAnchorEl] = useState(null);
    const open1 = Boolean(anchorEl);
    return (
        <>
            <Grid item width={'100%'}>
                <Typography variant="h5" fontWeight={600} justifyContent={'space-between'} display={'flex'} paddingBottom={'8px'}>
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'wrap', // allows wrapping
                            gap: '12px',
                            alignItems: 'flex-start', // aligns top when wrapped
                            justifyContent: 'flex-start',
                        }}
                    >
                        <Chip
                            style={{
                                display: 'flex',
                                padding: '7px 10px',
                                borderRadius: '100px',
                                fontSize: '13px',
                                fontWeight: '500',
                                lineHeight: '18px',
                                letterSpacing: '0.16px',
                                background:
                                    type == SHOP_CREATED
                                        ? CHIP_COLOR.SHOP_CREATED_BG
                                        : type == SHOP_IMPORTED
                                          ? CHIP_COLOR.SHOP_IMPORTED_BG
                                          : type == WALK_IN
                                            ? '#FFA969'
                                            : type === 'shop_guest'
                                              ? CHIP_COLOR.SHOP_IMPORTED_BG
                                              : CHIP_COLOR.APEX_AUTO_APP_BG,
                                color:
                                    type == SHOP_CREATED
                                        ? CHIP_COLOR.SHOP_CREATED_COLOR
                                        : type == SHOP_IMPORTED
                                          ? CHIP_COLOR.SHOP_IMPORTED_COLOR
                                          : type == WALK_IN
                                            ? 'rgba(0,0,0,0.87)'
                                            : type === 'shop_guest'
                                              ? CHIP_COLOR.SHOP_IMPORTED_COLOR
                                              : CHIP_COLOR.APEX_AUTO_APP_COLOR,
                            }}
                            label={
                                type == SHOP_CREATED
                                    ? 'Shop Created'
                                    : type == SHOP_IMPORTED
                                      ? 'Shop Imported'
                                      : type == WALK_IN
                                        ? 'Walk In'
                                        : type === 'shop_guest'
                                          ? 'Guest'
                                          : 'Apex Auto'
                            }
                        />
                        {/* {console.log('data?.isFleetCustomer', data)} */}
                        {(type == SHOP_IMPORTED || type == WALK_IN ? importedCustomerData?.isFleetCustomer : data?.isFleetCustomer) && (
                            <Chip
                                label={'Fleet Customer'}
                                sx={{
                                    background: CHIP_COLOR.FLEET_CUSTOMER,
                                    color: 'rgba(0, 0, 0, 0.87)',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    lineHeight: '18px',
                                    letterSpacing: '0.16px',
                                }}
                            />
                        )}
                    </div>

                    {!isRestrictedCustomerType && (
                        <span onClick={() => setQuickEdit(true)}>
                            {' '}
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" cursor={'pointer'}>
                                <path
                                    d="M0 18V13.75L13.2 0.575C13.4 0.391667 13.621 0.25 13.863 0.15C14.105 0.0500001 14.359 0 14.625 0C14.891 0 15.1493 0.0500001 15.4 0.15C15.6507 0.25 15.8673 0.4 16.05 0.6L17.425 2C17.625 2.18333 17.771 2.4 17.863 2.65C17.955 2.9 18.0007 3.15 18 3.4C18 3.66667 17.9543 3.921 17.863 4.163C17.7717 4.405 17.6257 4.62567 17.425 4.825L4.25 18H0ZM14.6 4.8L16 3.4L14.6 2L13.2 3.4L14.6 4.8Z"
                                    fill="black"
                                    fillOpacity="0.6"
                                />
                            </svg>
                        </span>
                    )}
                </Typography>

                <Typography variant="body1" fontWeight={400} pt={1} fontSize={'24px'}>
                    {type == SHOP_IMPORTED || type == WALK_IN
                        ? importedCustomerData?.firstName + ' ' + importedCustomerData?.lastName
                        : data?.firstName + ' ' + data?.lastName}
                </Typography>

                {/* 1. Balance Owing */}
                {(() => {
                    const balanceVal = type == SHOP_IMPORTED || type == WALK_IN ? importedCustomerData?.balanceOwing : data?.balanceOwing;
                    const hasBalance = balanceVal !== undefined && balanceVal !== null && balanceVal !== '' && !isNaN(Number(balanceVal));
                    if (!hasBalance) return null;
                    const formattedVal = NumericEngine.format(balanceVal, { formatCurrency: true, trailingZeros: true });

                    return (
                        <>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    width: '100%',
                                    paddingTop: '12px',
                                }}
                            >
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <BalanceOwingSvg />
                                    <Typography
                                        style={{
                                            color: 'rgba(0, 0, 0, 0.60)',
                                            fontSize: '16px',
                                            fontWeight: 400,
                                            lineHeight: '143%',
                                            letterSpacing: '0.17px',
                                        }}
                                    >
                                        Balance Owing
                                    </Typography>
                                </div>
                                <Typography
                                    style={{
                                        color: '#D32F2F',
                                        fontSize: '16px',
                                        fontWeight: 600,
                                        lineHeight: '143%',
                                        letterSpacing: '0.17px',
                                        textAlign: 'right',
                                    }}
                                >
                                    {formattedVal}
                                </Typography>
                            </div>
                            <Divider style={{ width: '100%', borderColor: '#E0E0E0', marginTop: '12px' }} />
                        </>
                    );
                })()}

                {/* 2. Phone Numbers & Email Section */}
                {/* Primary Phone */}
                {(() => {
                    const pNum = type == SHOP_IMPORTED || type == WALK_IN ? importedCustomerData?.phoneNumber : data?.phoneNumber;
                    const pType = type == SHOP_IMPORTED || type == WALK_IN ? 'mobile' : data?.primaryPhoneNumberType;
                    const formattedNum = formatPhoneNumber(pNum);
                    if (!formattedNum) return null;

                    const getPhoneTypeLabel = (pt) => {
                        if (!pt) return 'Mobile';
                        const lower = String(pt).toLowerCase();
                        if (lower === 'home') return 'Home';
                        if (lower === 'landline') return 'Landline';
                        if (lower === 'work') return 'Work';
                        return 'Mobile';
                    };

                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingTop: '12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {PhoneTypeIcon(pType)}
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.60)',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        lineHeight: '143%',
                                        letterSpacing: '0.17px',
                                    }}
                                >
                                    {getPhoneTypeLabel(pType)}
                                </Typography>
                            </div>
                            <Typography
                                style={{
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    lineHeight: '143%',
                                    letterSpacing: '0.17px',
                                    textAlign: 'right',
                                }}
                            >
                                {formattedNum}
                            </Typography>
                        </div>
                    );
                })()}

                {/* Secondary Phone */}
                {(() => {
                    const sNum = type == SHOP_IMPORTED || type == WALK_IN ? importedCustomerData?.secondaryPhoneNumber : data?.secondaryPhoneNumber;
                    const sType = type == SHOP_IMPORTED || type == WALK_IN ? 'mobile' : data?.secondaryPhoneNumberType;
                    const formattedNum = formatPhoneNumber(sNum);
                    if (!formattedNum) return null;

                    const getPhoneTypeLabel = (pt) => {
                        if (!pt) return 'Mobile';
                        const lower = String(pt).toLowerCase();
                        if (lower === 'home') return 'Home';
                        if (lower === 'landline') return 'Landline';
                        if (lower === 'work') return 'Work';
                        return 'Mobile';
                    };

                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingTop: '12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {PhoneTypeIcon(sType)}
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.60)',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        lineHeight: '143%',
                                        letterSpacing: '0.17px',
                                    }}
                                >
                                    {getPhoneTypeLabel(sType)}
                                </Typography>
                            </div>
                            <Typography
                                style={{
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    lineHeight: '143%',
                                    letterSpacing: '0.17px',
                                    textAlign: 'right',
                                }}
                            >
                                {formattedNum}
                            </Typography>
                        </div>
                    );
                })()}

                {/* Primary Email */}
                {(() => {
                    const mail = type == SHOP_IMPORTED || type == WALK_IN ? importedCustomerData?.email : data?.email;
                    if (!mail) return null;

                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingTop: '12px', gap: '12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                                <div style={{ width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path
                                            d="M16.667 3.33337H3.33366C2.41699 3.33337 1.67533 4.08337 1.67533 5.00004L1.66699 15C1.66699 15.9167 2.41699 16.6667 3.33366 16.6667H16.667C17.5837 16.6667 18.3337 15.9167 18.3337 15V5.00004C18.3337 4.08337 17.5837 3.33337 16.667 3.33337ZM16.667 6.66671L10.0003 10.8334L3.33366 6.66671V5.00004L10.0003 9.16671L16.667 5.00004V6.66671Z"
                                            fill="#006CDD"
                                        />
                                    </svg>
                                </div>
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.60)',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        lineHeight: '143%',
                                        letterSpacing: '0.17px',
                                    }}
                                >
                                    Email
                                </Typography>
                            </div>
                            <EllipsisEmail email={mail} />
                        </div>
                    );
                })()}

                {/* Secondary Email */}
                {(() => {
                    const sMail = type == SHOP_IMPORTED || type == WALK_IN ? importedCustomerData?.secondaryEmail : data?.secondaryEmail;
                    if (!sMail) return null;

                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingTop: '12px', gap: '12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                                <div style={{ width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path
                                            d="M16.667 3.33337H3.33366C2.41699 3.33337 1.67533 4.08337 1.67533 5.00004L1.66699 15C1.66699 15.9167 2.41699 16.6667 3.33366 16.6667H16.667C17.5837 16.6667 18.3337 15.9167 18.3337 15V5.00004C18.3337 4.08337 17.5837 3.33337 16.667 3.33337ZM16.667 6.66671L10.0003 10.8334L3.33366 6.66671V5.00004L10.0003 9.16671L16.667 5.00004V6.66671Z"
                                            fill="#006CDD"
                                        />
                                    </svg>
                                </div>
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.60)',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        lineHeight: '143%',
                                        letterSpacing: '0.17px',
                                    }}
                                >
                                    Secondary Email
                                </Typography>
                            </div>
                            <EllipsisEmail email={sMail} />
                        </div>
                    );
                })()}

                {/* Divider between Phone/Email & Company/Tax/Address */}
                {(() => {
                    const comp = type == SHOP_IMPORTED || type == WALK_IN ? importedCustomerData?.company : data?.company;
                    const taxNum = type == SHOP_IMPORTED || type == WALK_IN ? importedCustomerData?.taxExemptionNumber : data?.taxExemptionNumber;
                    const addr = type == SHOP_IMPORTED || type == WALK_IN ? importCustomerAddress()?.trim() : customerAddress()?.trim();

                    if (comp || taxNum || addr) {
                        return <Divider style={{ width: '100%', borderColor: '#E0E0E0', marginTop: '12px' }} />;
                    }
                    return null;
                })()}

                {/* 3. Company, Tax Exemption, Address */}
                {/* Company */}
                {(() => {
                    const comp = type == SHOP_IMPORTED || type == WALK_IN ? importedCustomerData?.company : data?.company;
                    if (!comp) return null;

                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingTop: '12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <WorkIcon style={{ color: '#006CDD', fontSize: '20px' }} />
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.60)',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        lineHeight: '143%',
                                        letterSpacing: '0.17px',
                                    }}
                                >
                                    Company
                                </Typography>
                            </div>
                            <Typography
                                style={{
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    lineHeight: '143%',
                                    letterSpacing: '0.17px',
                                    textAlign: 'right',
                                }}
                            >
                                {comp}
                            </Typography>
                        </div>
                    );
                })()}

                {/* Tax Exemption */}
                {(() => {
                    const taxNum = type == SHOP_IMPORTED || type == WALK_IN ? importedCustomerData?.taxExemptionNumber : data?.taxExemptionNumber;
                    if (!taxNum) return null;

                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingTop: '12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <TaxExemptionSvg />
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.60)',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        lineHeight: '143%',
                                        letterSpacing: '0.17px',
                                    }}
                                >
                                    Tax Exemption
                                </Typography>
                            </div>
                            <Typography
                                style={{
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    lineHeight: '143%',
                                    letterSpacing: '0.17px',
                                    textAlign: 'right',
                                }}
                            >
                                {taxNum}
                            </Typography>
                        </div>
                    );
                })()}

                {/* Address */}
                {(() => {
                    const addr = type == SHOP_IMPORTED || type == WALK_IN ? importCustomerAddress()?.trim() : customerAddress()?.trim();
                    if (!addr) return null;

                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%', paddingTop: '12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
                                <LocationOnIcon style={{ color: '#006CDD', fontSize: '20px' }} />
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.60)',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        lineHeight: '143%',
                                        letterSpacing: '0.17px',
                                    }}
                                >
                                    Address
                                </Typography>
                            </div>
                            <Typography
                                style={{
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    lineHeight: '143%',
                                    letterSpacing: '0.17px',
                                    textAlign: 'right',
                                    maxWidth: '220px',
                                    wordBreak: 'break-word',
                                }}
                            >
                                {addr}
                            </Typography>
                        </div>
                    );
                })()}

                {/* Divider between Company/Tax/Address & Preferences */}
                {(() => {
                    if (data?.contactPrefrence) {
                        return <Divider style={{ width: '100%', borderColor: '#E0E0E0', marginTop: '12px' }} />;
                    }
                    return null;
                })()}

                {/* 4. Contact Preference */}
                {(() => {
                    if (!data?.contactPrefrence) return null;
                    const prefValue = CONTACT_PREFRENCES?.filter((d) => d.key == data?.contactPrefrence)[0]?.value;

                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingTop: '12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <ContactPreferenceSvg />
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.60)',
                                        fontSize: '16px',
                                        fontWeight: 400,
                                        lineHeight: '143%',
                                        letterSpacing: '0.17px',
                                    }}
                                >
                                    Contact Preference
                                </Typography>
                            </div>
                            <Typography
                                style={{
                                    fontSize: '16px',
                                    fontWeight: 400,
                                    lineHeight: '143%',
                                    letterSpacing: '0.17px',
                                    textAlign: 'right',
                                }}
                            >
                                {prefValue}
                            </Typography>
                        </div>
                    );
                })()}

                {/* 5. Notifications (Commented out for future use) */}
                {/* {(() => {
                    if (!data?.notifications) return null;
                    return (
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', paddingTop: '12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <NotificationsSvg />
                                <Typography
                                    style={{
                                        color: 'rgba(0, 0, 0, 0.60)',
                                        fontSize: '14px',
                                        fontWeight: 400,
                                        lineHeight: '143%',
                                        letterSpacing: '0.17px',
                                    }}
                                >
                                    Notifications
                                </Typography>
                            </div>
                            <Typography
                                style={{
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    lineHeight: '143%',
                                    letterSpacing: '0.17px',
                                    textAlign: 'right',
                                }}
                            >
                                {data?.notifications}
                            </Typography>
                        </div>
                    );
                })()} */}

                {!isRestrictedCustomerType && <Divider style={{ width: '100%', borderColor: '#E0E0E0', marginTop: '11px' }} />}

                {data?.membershipProgram?.discount && (
                    <>
                        <Typography variant="body1" fontWeight={400} paddingTop={'20px'} paddingBottom={'4px'} display={'flex'} gap={'8px'}>
                            <Chip
                                sx={{
                                    background: '#EBEBEB',
                                    color: '#000',
                                }}
                                label={`${data?.membershipProgram.discount}%`}
                            />
                            <span
                                style={{
                                    justifyContent: 'center',
                                    display: 'flex',
                                    alignItems: 'center',

                                    lineHeight: 'normal',
                                }}
                            >
                                {data?.membershipProgram?.programName}
                            </span>
                        </Typography>
                    </>
                )}
            </Grid>
            <Grid item container justifyContent={'end'} paddingRight={'16px'} paddingTop={'16px'}>
                <Stack spacing={2} direction={'row'}>
                    {!isRestrictedCustomerType && (
                        <Button
                            variant="contained"
                            onClick={() => {
                                navigate(`/messenger/${id}`);
                            }}
                        >
                            SEND MESSAGE
                        </Button>
                    )}
                    {(type == SHOP_CREATED || type == APEX_AUTO_APP) && (
                        <Button
                            variant="contained"
                            endIcon={<ExpandMoreIcon />}
                            id="demo-positioned-button"
                            onClick={(event) => {
                                setAnchorEl(event.currentTarget);
                            }}
                        >
                            ACTIONS{' '}
                        </Button>
                    )}
                    <Menu
                        id="demo-positioned-menu"
                        aria-labelledby="demo-positioned-button"
                        anchorEl={anchorEl}
                        open={open1}
                        onClose={() => setAnchorEl(null)}
                        // anchorOrigin={{
                        //     vertical: 'top',
                        //     horizontal: 'left',
                        // }}
                        // transformOrigin={{
                        //     vertical: 'top',
                        //     horizontal: 'left',
                        // }}
                        onClick={() => setAnchorEl(null)}
                    >
                        <MenuItem
                            onClick={() => {
                                setOpenEditCustomer(true);
                            }}
                        >
                            <EditIcon
                                style={{
                                    marginRight: '10px',
                                    color: 'rgba(0, 0, 0, 0.87)',
                                }}
                            />{' '}
                            Edit Customer
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                setStatementAccountModal(true);
                                setAnchorEl(null);
                            }}
                        >
                            <Download
                                style={{
                                    marginRight: '10px',
                                    color: 'rgba(0, 0, 0, 0.87)',
                                }}
                            />{' '}
                            Share Statement of Account
                        </MenuItem>
                        <MenuItem
                            onClick={() => {
                                setRecordPaymentParams({
                                    ...recordPaymentParams,
                                    customer: [id],
                                });
                                setCustomerDetail(data);
                                navigate('/invoice/record-payment');
                            }}
                        >
                            <RecordPaymentSvg style={{ marginRight: '10px' }} />
                            Record Payment
                        </MenuItem>
                        {type == SHOP_CREATED && (
                            <MenuItem onClick={() => setOpenDelete(true)} style={{ color: '#D32F2F' }}>
                                <DeleteIcon
                                    style={{
                                        marginRight: '10px',
                                        color: '#D32F2F',
                                    }}
                                />
                                Delete Customer
                            </MenuItem>
                        )}
                    </Menu>
                </Stack>
            </Grid>

            <StatementAccountReportModal open={statementAccountModal} close={setStatementAccountModal} id={id} data={data} />
        </>
    );
}

export default CustomerProfileLeftDataSection;
